import { isStaff } from '@getslot/domain'
import { Button, ButtonLink } from '@getslot/ui-web/button'
import { Loading, Notice } from '@getslot/ui-web/notice'
import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { meQuery } from '../api/queries'
import { BOT_URL } from '../config'
import { useAuth } from './auth-provider'
import { TelegramLoginButton } from './telegram-login-button'

function LoginScreen() {
  return (
    <Notice
      title="Вход для операторов"
      actions={
        <>
          <TelegramLoginButton />
          <ButtonLink variant="secondary" href={BOT_URL}>
            Открыть бота в Telegram
          </ButtonLink>
        </>
      }
    >
      Войдите через Telegram тем аккаунтом, которому выдана роль оператора. Внутри Telegram админка открывается сама.
    </Notice>
  )
}

/** Роль проверяет API; здесь только решаем, что показать. Клиента в админку не пускаем. */
function StaffOnly({ children }: { children: ReactNode }) {
  const me = useQuery(meQuery)
  if (me.isPending) return <Loading />
  if (me.isError) throw me.error
  if (!isStaff(me.data.role)) {
    return <Notice title="Нет доступа">Этот аккаунт не оператор. Если это ошибка, напишите администратору.</Notice>
  }
  return children
}

export function AuthGate({ children }: { children: ReactNode }) {
  const { status, retry } = useAuth()
  switch (status) {
    case 'loading':
      return <Loading label="Входим" />
    case 'guest':
    case 'beta_closed':
      return <LoginScreen />
    case 'unavailable':
      return (
        <Notice
          title="Нет связи"
          actions={
            <Button variant="cta" onClick={retry}>
              Попробовать ещё раз
            </Button>
          }
        >
          Сервер не отвечает. Проверьте интернет или зайдите чуть позже.
        </Notice>
      )
    case 'ready':
      return <StaffOnly>{children}</StaffOnly>
  }
}
